import React from 'react';
import { Invoice, InvoiceLineItem, SKU } from '../../../../redux/billing/billing.types';
import { formatCurrency } from './utils';
import { CircleAlert, Equal, X } from 'lucide-react';

interface InvoiceDetailCalcProps {
  invoice: Invoice;
  skus: SKU[];
}

export const InvoiceDetailCalc: React.FC<InvoiceDetailCalcProps> = ({
  invoice,
  skus,
}) => {
  const useOverrideValue = (lineItem: InvoiceLineItem, field: keyof InvoiceLineItem) => {
    const overrideField = `${field}_override` as keyof InvoiceLineItem;
    const overrideValue = lineItem[overrideField];
    return overrideValue !== null && overrideValue !== undefined ? overrideValue : lineItem[field];
  };

  // const calculateMargin = () => {
  //   const spend = invoice.invoice_line_items.reduce((acc, item) => acc + (useOverrideValue(item, 'advertiser_spend') as number || 0), 0);
  //   const marginPct = invoice.invoice_line_items.reduce((acc, item) => acc + (useOverrideValue(item, 'margin_pct') as number || 0), 0);
  //   return spend * (marginPct / 100);
  // };
  const calculateRate = (invoice: Invoice) => {
    const qty = invoice.invoice_line_items.filter(item => !item.do_not_bill && !item.hide).reduce((acc, item) => acc + (useOverrideValue(item, 'qty') as number == 1 ? 1 : useOverrideValue(item, 'qty') as number / 1000), 0);
    return invoice.invoice_line_items.filter(item => !item.do_not_bill && !item.hide).reduce((acc, item) => acc + (useOverrideValue(item, 'amount_to_bill') as number || 0), 0) / qty;
  };

  const calculateQty = (invoice: Invoice) => {
    return invoice.invoice_line_items.filter(item => !item.do_not_bill && !item.hide).reduce((acc, item) => acc + (useOverrideValue(item, 'qty') as number == 1 ? 1 : useOverrideValue(item, 'qty') as number / 1000), 0);
  };

  const hasDoNotBill = skus.some(sku => sku && sku.bill_type === 'do_not_bill');

  return (
    <>
      <div className='flex flex-col'>
        <div className='text-sm font-light text-gray-500'>
          Total
        </div>
        <div className='text-xl font-thin'>
          {calculateQty(invoice).toFixed(0)}
        </div>
        <div className='text-xs font-light text-gray-500'>
          Qty
        </div>
      </div>
      <div>
        <X className='h-4 w-4' />
      </div>
      <div className='flex flex-col'>
        <div className='text-sm font-light text-transparent'>
          {'L'}
        </div>
        <div className='text-xl font-thin'>
          {formatCurrency(calculateRate(invoice))}
        </div>
        <div className='text-xs font-light text-gray-500'>
          Rate
        </div>
      </div>
      <div>
        <Equal className='h-4 w-4' />
      </div>
      <div className='flex flex-col'>
        <div className='text-sm font-light text-transparent'>
          {hasDoNotBill ? (
            <div className="group relative flex items-center">
              <CircleAlert
                className='h-4 w-4 text-orange-500 ml-auto'
              />
              <span className="opacity-0 pointer-events-none group-hover:opacity-100 group-hover:pointer-events-auto transition-opacity absolute left-full ml-2 whitespace-nowrap bg-black text-white text-xs px-2 py-1 rounded z-10 shadow-lg">
                Some line items are marked with `Do Not Bill`
              </span>
            </div>
          ) : (
            'L'
          )}
        </div>
        <div className='text-xl font-thin'>
          {formatCurrency(calculateRate(invoice) * (calculateQty(invoice)))}
        </div>
        <div className='text-xs font-light text-gray-500'>
          Total
        </div>
      </div>
    </>
  );
};

export default InvoiceDetailCalc;
